import { Box, Typography } from "@mui/material"
import { theme } from "../../../utils/theme/godzilla_light"
import editFilledIcon from '../../../assets/images/svgs/EditFilled.svg'

const styles = {
    infoCardWrapper: {
        p: "21px 21px 35px 40px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        border: "1px solid #CECBCA",
        mt: "1.5rem",
        flex: 1
    },
    iconCursor: {
        cursor: "pointer",
        ml: "10px",
        height: "28px",
        width: "28px",
        borderRadius: "14px",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        ':hover': {
            backgroundColor: "#5557591F"
        }
    },
    itemTitleStyle: {
        ...theme.typography.components.inputLabel,
        whiteSpace: "normal",
        wordBreak: "break-word"
    }
}

interface IItemProps {
    itemTitle: string;
    itemContent: string;
    itemSubContent?: string;
}

interface IInfoCardProps {
    titleCard: string;
    itemData?: IItemProps[];
    handleEditClick?: () => void;
}

export const InformationCard = (props: IInfoCardProps) => {
    const { titleCard, itemData, handleEditClick } = props

    return (
        <Box sx={styles.infoCardWrapper} textAlign={"left"} minWidth={"208px"}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ ...theme.typography.opticianBodyRegular, mt: "8px", fontSize: "24px" }}>{titleCard}</Typography>
                <Box onClick={handleEditClick} sx={styles.iconCursor}>
                    <img src={editFilledIcon} alt="edit-icon" />
                </Box>
            </Box>

            {itemData && itemData?.length > 0 ?
                itemData?.map((item: IItemProps, index: number) => (
                    <Box key={index + 1} sx={{ mt: "20px" }}>
                        <Typography sx={styles.itemTitleStyle}>
                            {item.itemTitle}
                        </Typography>
                        <Typography sx={{ ...styles.itemTitleStyle, ...theme.typography.components.inputText }}>
                            {item.itemContent}
                        </Typography>
                        {item.itemSubContent ?
                            <Typography sx={{ ...theme.typography.components.inputText }}>
                                {item.itemSubContent}
                            </Typography>
                            : null}
                    </Box>
                ))
                : null}
        </Box>
    )
}